import React, { FC } from 'react'

interface AppsRunningProps {
    title: string,
    subtitle?: string,
    bgImage?: string
}

const AppsRunning: FC<AppsRunningProps> = ({ title, subtitle, bgImage }) => {
    return (
        <div>
            <div className='border-t-8 border-darkGreyTernary mx-4 sm:mx-8 md:mx-12'></div>
            <div className={`bg-yellow text-center p-4 sm:p-8 md:p-16 w-full text-black ${bgImage} bg-center bg-cover bg-no-repeat`}>
                <div className='text-xl sm:text-2xl md:text-4xl font-bold mb-2 sm:mb-3 md:mb-4'>{title}</div>
                <div className='text-base sm:text-lg md:text-xl leading-6 sm:leading-7 md:leading-8 px-2 sm:px-4 md:px-6'>{subtitle}</div>
            </div>
            <div className='border-b-8 border-darkGreyTernary mx-4 sm:mx-8 md:mx-12'></div>
        </div>
    )
}

export default AppsRunning
